import { PlaItem, TextAdItem } from '../types';

export type SortBy = 'Freq.' | 'Position' | 'Price';
export type SortDirection = 'asc' | 'desc';

/**
 * Sort PLA items by frequency, position, or price.
 *
 * - Stable copy: sorts a cloned array to avoid mutating callers
 * - Direction controls ascending/descending
 *
 * @param items PLA items to sort.
 * @param sortBy Sort field: 'Freq.' | 'Position' | 'Price'.
 * @param direction Sort direction: 'asc' | 'desc'.
 * @returns New sorted array.
 */
export function sortPlaItems(items: PlaItem[], sortBy: SortBy, direction: SortDirection): PlaItem[] {
    const arr = [...items];
    const m = direction === 'asc' ? 1 : -1;
    switch (sortBy) {
        case 'Freq.':
            return arr.sort((a, b) => (a.frequency - b.frequency) * m);
        case 'Position':
            return arr.sort((a, b) => (a.position - b.position) * m);
        case 'Price':
            return arr.sort((a, b) => {
                const priceA = parseFloat(a.price.replace(/[^0-9.]/g, ''));
                const priceB = parseFloat(b.price.replace(/[^0-9.]/g, ''));
                return (priceA - priceB) * m;
            });
        default:
            return arr;
    }
}

/**
 * Sort Text Ads by frequency, position, or price.
 *
 * Note: Price sorting is aligned to frequency here (domain-specific behavior).
 *
 * @param items Text ads to sort.
 * @param sortBy Sort field: 'Freq.' | 'Position' | 'Price'.
 * @param direction Sort direction: 'asc' | 'desc'.
 * @returns New sorted array.
 */
export function sortTextAds(items: TextAdItem[], sortBy: SortBy, direction: SortDirection): TextAdItem[] {
    const arr = [...items];
    const m = direction === 'asc' ? 1 : -1;
    switch (sortBy) {
        case 'Freq.':
            return arr.sort((a, b) => (a.frequency - b.frequency) * m);
        case 'Position':
            return arr.sort((a, b) => (a.position - b.position) * m);
        case 'Price':
            return arr.sort((a, b) => (a.frequency - b.frequency) * m);
        default:
            return arr;
    }
}


